import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import { GetNotificatioInput, GetNotificationResponse, GetTokenLineResponse, TestMessagingResponse, UpdateLineTokenInput, UpdateLineTokenResponse, UpdateNotificatioInput, UpdateNotificationResponse, } from './interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'


export const getTokenLine = async (): Promise<GetTokenLineResponse> => {
  const data: AxiosResponse<GetTokenLineResponse> = await httpClient
    .post(API.getTokenLine)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateTokenLine = async (
  input: UpdateLineTokenInput
): Promise<UpdateLineTokenResponse> => {
  const data: AxiosResponse<UpdateLineTokenResponse> = await httpClient
    .post(API.updateTokenLine, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const testMessagingLine = async (): Promise<TestMessagingResponse> => {
    const data: AxiosResponse<TestMessagingResponse> = await httpClient
      .get(API.testMessageLine)
      .catch((error) => handleResponseError(error))
    return data.data
  }
